<template>
  <div id="NoticeList">
    <div class="list"
         v-for="(notice, index) in notices"
         :key="index"
         @click="routeDetail(notice.uuid)">
      <div class="left">
        <span class="title">{{ notice.title }}</span>
        <span class="date">{{ notice.created }}</span>
      </div>
      <div class="right">
        <img src="@/assets/images/btn-btn-now-sins-arrow.svg" alt="right-arrow"/>
      </div>
    </div>
  </div>
</template>

<script>
import noticeApi from '@/api/now/noticeApi'

export default {
  name: 'NoticeList',
  components: {
  },
  chimera: {
  },
  data: function () {
    return {
      notices: {}
    }
  },
  computed: {},
  async created() {
    await this.setNotices()
  },
  methods: {
    async setNotices() {
      let { data } = await noticeApi.getNotices()
      this.notices = data
    },
    routeDetail(uuid) {
      this.$router.push({
        name: 'notices/:uuid',
        params: {
          uuid: uuid
        }
      })
    }
  },
}
</script>
<style lang="scss" scoped>
  #NoticeList {
    width: 100%;
    max-width: inherit;
    min-height: calc(100vh - 60px);
    background: #ffffff;
    padding-left: 25px;
    padding-right: 25px;
    .list {
      width: 100%;
      border-bottom: solid 1px #e1e9f3;
      padding-top: 25px;
      padding-bottom: 25px;
      font-size: 16px;
      font-weight: 600;
      color: #333333;
      line-height: 1.25;
      letter-spacing: normal;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left {
        display: flex;
        flex-direction: column;
        span {
          &.title {
            line-height: 20px;
          }
          &.date {
            font-size: 13px;
            margin-top: 10px;
            line-height: 16px;
            color: #727d8c;
          }
        }
      }
      .right {
        display: flex;
        height: 46px;
        align-items: center;
        justify-content: center;
      }
    }
  }
</style>
